import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../../auth.service";
import { PasswordService } from "../../services/reset-password.service";
import { BehaviorSubject } from "rxjs";
import { Messages } from "../../model/messages";
import { ActionButtonSubmit } from "../../model/action-button-submit";

@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.css"],
})
export class ResetPasswordComponent {
  form: FormGroup;
  token: string = "";
  messages = new BehaviorSubject<Messages>(Messages.EMPTY);
  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private auth: AuthService,
    private router: Router,
    private passwordService: PasswordService
  ) {
    this.form = this.fb.group({
      password: "",
      confirmPassword: "",
    });

    this.route.paramMap.subscribe((params) => {
      this.token = params.get("token") || "";
    });
  }

  passwordMatchValidator(group: FormGroup) {
    return group.get("password")?.value === group.get("confirmPassword")?.value
      ? null
      : { mismatch: true };
  }
  onSubmit(action?: ActionButtonSubmit) {
    if (this.form.valid && this.token) {
      const { password, confirmPassword } = this.form.value;

      this.passwordService
        .resetPassword(this.token, password, confirmPassword)
        .subscribe(
          (messages) => {
            if (messages.empty) {
              this.router.navigate(["/login"]);
              action?.result(true);
            } else {
              this.messages.next(messages);
              action?.result(false);
            }
          },
          (error) => {
            this.messages.next(
              Messages.from({ password: ["resetPassword.error"] })
            );
            action?.result(false);
          }
        );
    } else {
      this.messages.next(
        Messages.from({ password: ["resetPassword.invalidForm"] })
      );
      action?.result(false);
    }
  }
}
